import { render, staticRenderFns } from "./Simulations.vue?vue&type=template&id=6ba579f4"
import script from "./Simulations.vue?vue&type=script&lang=js"
export * from "./Simulations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports